import { nextIterationAsync } from "./_nextIterationAsync.js";
import { typeDataToArray } from "./_typeDataToArray.js";
export const toObjectAsync = async (source, selector) => {
    const dataFunc = nextIterationAsync(source, async (value) => {
        const key = await selector(value);
        return [key, value];
    });
    const keyValues = await typeDataToArray(dataFunc);
    const map = {};
    for (const [key, value] of keyValues) {
        map[key] = value;
    }
    return map;
};
